//import axios from 'axios';
import localforage from 'localforage'
import memoryDriver from 'localforage-memoryStorageDriver'
import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import {interceptorResponse, interceptorError} from '@/helpers/interceptorResponse';


class API {  
  async configure(){
    const DB_NAME = "infohidro-geosimepar";
    // await localforage.defineDriver(memoryDriver);

    const forageStore = localforage.createInstance({
      driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
      ],
      name: DB_NAME
    });

    const cache = setupCache({
      // {Number} Maximum time for storing each request in milliseconds,
      // defaults to 15 minutes when using `setup()`.
      maxAge: 24 * 60 * 60 * 1000,
      // {Number} Maximum number of cached request (last in, first out queue system),
      // defaults to `false` for no limit. *Cannot be overridden per request*
      limit: 40,
      // {Object} An instance of localforage, defaults to a custom in memory store.
      // *Cannot be overridden per request*
      store: forageStore,  
      // {Function|Boolean} Determine if stale cache should be read when a network error occurs.      
      readOnError: (error) => {
        // Attempt reading stale cache data when response status is either 4xx or 5xx
        return error.response.status >= 400 && error.response.status < 600
      },
      // {Boolean} Clear cached item when it is stale.
      // clearOnStale: true,
      // Deactivate `clearOnStale` option so that we can actually read stale cache data
      // By default axios-cache-adapter clears stale cache data automatically, this would conflict with activating the readOnError option, so the clearOnStale option should be set to false.
      clearOnStale: false,
      // key {Mixed}: Can either be a String or a Function which receives the request object as
      // first parameter to return a unique cache key for each request. Defaults to req => req.url
      key: req => { 
        // normalize key (whithout server domain)
        const NORMALIZED_KEY = req.url.replace(`${process.env.VUE_APP_API_PRODUTOS_URL}`,"");
        return NORMALIZED_KEY;
      },
      // {Function} Invalidate stored cache. By default will remove cache when
      // making a request with method not `GET`, `POST`, `PUT`, `PATCH` or `DELETE` query.  
      // invalidate: async (cfg, req) => {
      //   const method = req.method.toLowerCase()
      //   console.log('invalidate', cfg.uuid, method, req)
      //   if (method !== 'get') {
      //     await cfg.store.removeItem(cfg.uuid)
      //   }
      // },
      // {Boolean} Determine if response headers should be read to set `maxAge` automatically.
      // Will try to parse `cache-control` or `expires` headers.
      // readHeaders: false,
      // {Boolean} Ignore cache, will force to interpret cache reads as a `cache-miss`.
      // Useful to bypass cache for a given request.
      // ignoreCache: false,
      // {Function|Boolean} Print out debug log to console.
      // debug: true,
    });
    
    const api = axios.create({
      adapter: cache.adapter,
      baseURL: `${process.env.VUE_APP_API_BASE_GEOSIMEPAR}`,
    });

    api.interceptors.response.use(
      interceptorResponse,
      interceptorError
    );

    return api;
  }
}

export default API;